import React from 'react';

const Header = ({ currentDate }) => {
  const dayOfWeek = currentDate.toLocaleDateString('en-US', { weekday: 'long' });

  return (
    <div className="max-w-[1200px] mx-auto px-4">
      <div className="relative w-full h-[300px] overflow-hidden rounded-t-lg">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img 
            src="/dna_banner2.jpg"
            alt="DNA Banner"
            className="w-full h-full object-cover"
          />
          {/* Light overlay with cyan tint */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-900/10 to-black/15"></div>
        </div>

        {/* Content Container */}
        <div className="relative h-full flex flex-col items-center justify-between py-8">
          {/* Title - Moved up */}
          <h1 
            className="text-white text-3xl md:text-4xl font-bold text-center mt-4"
            style={{
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}
          >
            PROVERBS DAILY
          </h1>
          
          {/* Day of Week - Made larger and centered */}
          <h2 
            className="text-white text-5xl md:text-7xl font-bold text-center flex-grow flex items-center"
            style={{
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}
          >
            {dayOfWeek}
          </h2>
          
          {/* Empty div for spacing */}
          <div className="h-8"></div>
        </div>
      </div>
    </div>
  );
};

export default Header;